<template>
	<div class="tab-table-wrapper">
		<!-- 只有在 MenuList 里存在的才显示 -->
		<div class="tab-list">
			<el-button v-for="item in authorizedTabs" :key="item.value"
				:type="activeTab === item.value ? 'primary' : 'default'" @click="handleTabChange(item.value)">
				{{ item.label }}
			</el-button>
		</div>

		<!-- 只渲染有权限的组件 -->
		<div class="tab-content" v-if="activeTab">
			<component :is="activeTab" :key="activeTab" />
		</div>
	</div>
</template>

<script>
	// 你的组件
	import TokenStatCard from './comtent/TokenStatCard.vue'
	import TimeToken from './comtent/TimeToken.vue'
	import SubjectToken from './comtent/SubjectToken.vue'
	import StudentToken from './comtent/StudentToken.vue'
	import GradeToken from './comtent/GradeToken.vue'
	import ClassToken from './comtent/ClassToken.vue'
	import Agent‌Square from './comtent/Agent‌Square.vue'
	import HtmlCount from './comtent/HtmlCount.vue'

	export default {
		name: 'TabTableContainer',
		components: {
			tokenStatCard: TokenStatCard,
			timeToken: TimeToken,
			subjectToken: SubjectToken,
			studentToken: StudentToken,
			gradeToken: GradeToken,
			classToken:ClassToken,
			IntelligentAgentSquare: Agent‌Square,
			htmlCount:HtmlCount,
		},
		data() {
			return {
				tabs: [{
						label: '智能体广场',
						value: 'IntelligentAgentSquare'
					},
					{
						label: '学校汇总',
						value: 'tokenStatCard'
					},
					// { label: '学期统计', value: 'timeToken' },
					{
						label: '年级统计',
						value: 'gradeToken'
					},
					{
						label: '学科统计',
						value: 'subjectToken'
					},
					{
						label: '班级统计',
						value: 'classToken'
					},
					{ label: '学生统计', value: 'studentToken' },
					{ label: '网页分层统计', value: 'htmlCount' },
				],
				activeTab: ''
			}
		},
		computed: {
			// 从 localStorage 读取菜单权限
			menuList() {
				try {
					return localStorage.getItem('MenuList') || ''
				} catch (e) {
					return ''
				}
			},

			// 核心：只保留 MenuList 中存在的 tab
			authorizedTabs() {
				return this.tabs.filter(tab => {
					return this.menuList.includes(tab.value)
				})
			}
		},
		created() {
			this.setDefaultTab()
		},
		methods: {
			handleTabChange(value) {
				this.activeTab = value
			},
			// 默认选中第一个有权限的
			setDefaultTab() {
				if (this.authorizedTabs.length > 0) {
					this.activeTab = this.authorizedTabs[0].value
				}
			}
		}
	}
</script>

<style scoped>
	.tab-table-wrapper {
		width: 100%;
		min-height: calc(100vh - 76px);
		padding: 16px;
		box-sizing: border-box;
		background:
			radial-gradient(circle at 6% 0%, rgba(64, 158, 255, .11), transparent 28%),
			linear-gradient(180deg, #f7fbff 0%, #f4f7fb 100%);
	}

	.tab-list {
		display: inline-flex;
		gap: 6px;
		margin-bottom: 16px;
		padding: 6px;
		border-radius: 12px;
		background: rgba(255, 255, 255, .82);
		border: 1px solid rgba(126, 154, 186, .16);
		box-shadow: 0 10px 28px rgba(31, 65, 105, .07);
		backdrop-filter: blur(10px);
		max-width: 100%;
		overflow-x: auto;
		max-height: 10%;
	}

	.tab-list>>>.el-button {
		border: none;
		border-radius: 9px;
		padding: 9px 15px;
		margin: 0;
		color: #526174;
		background: transparent;
		font-weight: 600;
	}

	.tab-list>>>.el-button--primary {
		color: #fff;
		background: linear-gradient(135deg, #2f80ed, #42b4f5);
		box-shadow: 0 8px 18px rgba(47, 128, 237, .24);
	}

	.tab-content {
		width: 100%;
		height: 90%;
	}

	@media (max-width: 768px) {
		.tab-table-wrapper {
			padding: 10px;
		}

		.tab-list {
			display: flex;
		}
	}
</style>
